import BlockProjects from "./block-projects";

export default BlockProjects;